import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PagoService } from 'src/app/services/pago.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-consultar-pagos-modal-view-details',
  templateUrl: './modal-view-details.component.html',
  styleUrls: ['../consultar-pagos.component.scss'],
  providers: [SecurityService],
})
export class ConsultarPagosModalViewDetailsComponent implements OnInit {
  // Modales
  @ViewChild('verPago', { static: true }) modalVerPago: ModalDirective;

  // Form
  formHeader: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  public rutRecaudador: any;
  public nombreRecaudador: any;
  loading: boolean = false;
  pago: any = null;

  // Utils
  private log: any;
  // nro_pago: number = 0;
  private currentPayload: any = null;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private pagoService: PagoService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('CONSULTAR-PAGOS-DETAILS');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.createForms();
    this.formChangesSubscriptions();
  }

  private createForms() {
    // this.formHeader = this.fb.group({
    //   fecha_desde: [initDate, [Validators.required]],
    //   fecha_hasta: [currentDate, [Validators.required]],
    //   rutCliente: [null, []],
    //   codigo: [null, [Validators.required]],
    // });
  }

  private formChangesSubscriptions() {
    // this.formHeader.get("rutCliente").valueChanges
    //   .pipe(filter(Boolean), debounceTime(1000))
    //   .subscribe((rutCliente: string) => {
    //     this.modalSeleccionarCliente.searchByRut(rutCliente)
    //   })
  }

  loadAndShow(codigo: number, folio: number, fecha_pago: string) {
    // this.nro_pago = codigo;
    this.cleanup();
    this.modalVerPago.show();

    this.buscar(codigo, folio, fecha_pago);
  }

  cleanup() {
    this.loading = true;
    this.pago = null;
  }

  buscar(codigo: number, folio: number, fecha_pago: string) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    const fecha = this.obtenerFechaString(fecha_pago);

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        codigo: codigo,
        folio: folio,
        fecha_pago: fecha,
      },
    };

    this.currentPayload = inputParams;

    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;
    this.pagoService.obtenerPagoEspecifico(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      this.pago = respuesta;

      this.pago.saldoDocumento.forEach((pago) => {
        pago.abono = 0;
      });
      this.pago.difereciaPago.forEach((pago) => {
        pago.pagoAUtilizar = 0;
      });
      this.rutRecaudador = this.rutService.AgregarDV(this.pago.rut_recaudador);
      this.nombreRecaudador = this.pago.nombre_recaudador;

      // this.listaMovimientos.forEach(p => {
      //   p.rutFormato = this.rutService.AgregarDV(p.cliente_proveedor_rut)
      // })

      this.calcularTotales();
      this.loading = false;
    });
  }

  calcularTotales() {
    this.pago.totales = {
      saldoDocumento: {
        monto: _.sumBy(this.pago.saldoDocumento, 'monto'),
        pago: _.sumBy(this.pago.saldoDocumento, 'pago'),
        abono: _.sumBy(this.pago.saldoDocumento, 'abono'),
        saldo: _.sumBy(this.pago.saldoDocumento, 'saldo'),
      },
      difereciaPago: {
        saldo: _.sumBy(this.pago.difereciaPago, 'saldo'),
        // pagoAUtilizar: _.sumBy(this.pago.difereciaPago, 'pagoAUtilizar'),
      },
      forma_pago: _.sumBy(this.pago.forma_pago, 'monto'),
    };
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;
    inputParams.entidad.retornaExcel = type === 'XLS';
    inputParams.entidad.retornaPDF = type === 'PDF';

    this.log('inputParams', JSON.stringify(inputParams));
    this.pagoService.obtenerPagoEspecificoPDF(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.rutaArchivo);
    });
  }

  private obtenerFechaString(fecha?: string) {
    const fechaObj = fecha ? new Date(fecha) : null;
    if (fechaObj) {
      const day = fechaObj.getDate();
      const month = fechaObj.getMonth() + 1;
      const year = fechaObj.getFullYear();
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    }else{
      return null;
    }
  }
}
